import { memo } from 'react';
import { withTheme } from '@material-ui/core';

const MoreTimeOutlined = (props) => {
  const { color = props.theme.iconColor } = props;
  return (
    <svg width="18" height="17" viewBox="0 0 18 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.9165 5.33325V10.0833L10.6373 12.3791L11.2707 11.4291L8.104 9.52909V5.33325H6.9165Z"
        fill={color}
      />
      <path
        d="M13.1866 8.49984C13.2262 8.76109 13.2499 9.02234 13.2499 9.2915C13.2499 12.379 10.7958 14.8332 7.70825 14.8332C4.62075 14.8332 2.16659 12.379 2.16659 9.2915C2.16659 6.204 4.62075 3.74984 7.70825 3.74984C8.26242 3.74984 8.79284 3.829 9.29159 3.97942V2.34859C8.78492 2.22984 8.2545 2.1665 7.70825 2.1665C3.74992 2.1665 0.583252 5.33317 0.583252 9.2915C0.583252 13.2498 3.74992 16.4165 7.70825 16.4165C11.6666 16.4165 14.8333 13.2498 14.8333 9.2915C14.8333 9.02234 14.8174 8.76109 14.7858 8.49984H13.1866Z"
        fill={color}
      />
      <path
        d="M14.8333 2.95825V0.583252H13.25V2.95825H10.875V4.54158H13.25V6.91658H14.8333V4.54158H17.2083V2.95825H14.8333Z"
        fill={color}
      />
    </svg>
  );
};

export default withTheme()(memo(MoreTimeOutlined));
